import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import Chatroom from '../Chatroom/Chatroom.js';
import OfferBox from '../OfferBox/OfferBox';
import './App.css';
import Grid from '@material-ui/core/Grid';
import { withRouter} from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import leftIcon from '../../images/leftPointer.svg'
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";

class Settlement extends Component {
    
    componentDidMount(){
        this.props.getCaseInfo(localStorage.getItem('caseId'), localStorage.getItem('token'))
      }

    render(){
        
        // const { classes } = this.props;
        // const state = this.state;
        // console.log('CaseInformation classes: '+JSON.stringify(classes));
        // if(this.props.loadingCaseInfo){
        //     console.log('AN loadingCaseInfo')
        //     return(
        //         <CircularProgress size={50} thickness={3}/>
        //     );
        // }
        // else{ 
            return(
                <div className="App" style={{ width: '100%', height:'100%', marginTop:'0px' }}>

                <Grid
                container
                direction="row"
                justify="center"
                alignContent="center"
                >
                     <Grid
                        item
                        spacing={8}
                        md={12}
                        lg={12}
                        sm={12}
                        xs={12}
                        style={{marginBottom:'10px'}}
                        >
                        <div style={{height:'100px', backgroundColor:'#6C0E21', verticalAlign:'center'}}>
                        <Grid
                            container
                            direction="column"
                            spacing={12}
                            >
                                <Grid
                                    item
                                    // spacing={8}
                                    md={2}
                                    lg={2}
                                    sm={2}
                                    xs={2}
                                    style={{marginTop:'30px'}}
                                    >
                                    <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{    textAlign: 'left',
                                                                                                            color: 'white',
                                                                                                            marginLeft: '30px',
                                                                                                            fontWeight: 'bold',
                                                                                                            fontSize: '16px',
                                                                                                            float: 'left',
                                                                                                            height: '100%',
                                                                                                            verticalAlign: 'middle', }}>
                                    <img style={{width:'13%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                </Grid>
                                <Grid
                                    item
                                    // spacing={8}
                                    md={12}
                                    lg={12}
                                    sm={12}
                                    xs={12}
                                    // style={{marginBottom:'10px'}}
                                    >
                                    <h3 style={{ marginTop:'-25px',color:'white', textAlign:'center', fontWeight:'bolder', wordWrap: 'breakWord', whiteSpace: 'normal', fontSize:'17px', fontFamily:'Times New Roman Georgia' }}>
                                    {this.context.t('Settlement Chatroom')}
                                </h3>
                                </Grid>
                            </Grid>
                        </div>
                        
                    </Grid>
                    <h3 style={{ color:'#a52423', fontWeight:'bolder', wordWrap: 'breakWord', whiteSpace: 'normal', fontSize:'17px', fontFamily:'Times New Roman Georgia' }}>
                    {this.context.t('The Parties can negotiate for settlement in this page ')}<br></br> 
                    { localStorage.getItem('language') == 'en' ? this.context.t('and the Arbitrator cannot read the contents') :''}.
                    </h3>
                    
                    <Grid
                    container
                    direction="row"
                    justify="center"
                    alignContent="center"
                    >
                        <Grid
                        item
                        spacing={8}
                        md={6}
                        lg={6}
                        sm={6}
                        xs={10}
                        >
                            <OfferBox />
                        </Grid>
                        <Grid
                        item
                        spacing={8}
                        md={10}
                        lg={10}
                        sm={10}
                        xs={10}
                        >
                            <Chatroom />
                        </Grid>
                        
                    </Grid>
                </Grid>
                </div>
            );
        // }
    }

}

const mapStateToProps = (state) => {
    // console.log('mapStateToProps: state: '+JSON.stringify(state));
    return {
        //error: state.caseInfo.error,
        caseId: state.caseInfo.caseId,
        caseData: state.caseInfo.caseData,
        loadingCaseInfo: state.caseInfo.loading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getCaseInfo: (caseId, uniqueId) => dispatch(actions.getCaseInfo(caseId, uniqueId)),
    }
}

Settlement.contextTypes = {
    t: PropTypes.func
  }

export default (connect(mapStateToProps, mapDispatchToProps)(withRouter(Settlement)));